import React from 'react';
import __get_users from './../user-list/userdata';
import profileIcon from '../../../assets/img/proicon.png';
import { Scrollbars } from 'react-custom-scrollbars';

const usersList = [];
__get_users(function (users) {
  var i = 0;
  for (i = 0; i < users.length; i++) {
    usersList.push(users[i])
  }
});


const UserPicker = ({ onuserPicked, filter,message }) => {
  const filteredUsers = usersList.filter(item => item.firstName.toLowerCase().includes(message.toLowerCase())
  || item.lastName.toLowerCase().includes(message.toLowerCase()));  
      return (
        <Scrollbars autoHeight autoHeightMin={200}
    thumbMinSize={30} >
        <ul class="ulstyle">
         {filteredUsers.map(item =>
           <li class="ulstyle" style={{ cursor: "pointer" }} onClick={() => onuserPicked(item.firstName, item.lastName, item.email)}>
                  {item.photoURL == null ? (
                    <img alt="blockimg" src={profileIcon} style={{ width: '20px', height: '20px', borderRadius: '5px' }} />
                  ) : <img alt="blockimg" src={item.photoURL} style={{ width: '20px', height: '20px', borderRadius: '5px' }} />
                  }
               &nbsp;&nbsp;&nbsp;{item.firstName + " " + item.lastName}</li>
         )}
        </ul>
        </Scrollbars>
      );
};

export default UserPicker;